import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
export const addOrEditWarehouse = (params, isEdit) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse`,
    method: isEdit ? "PUT" : "POST",
    data: params,
  });
};
export const delWarehouse = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse/${ids}`,
    method: "DELETE",
  });
};
// 获取列表
export const getWarehouseList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse?` + params,
    method: "GET",
  });
};
// 获取详情
export const getWarehouseDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse/${id}`,
    method: "GET",
  });
};
//获取商品列表
export const getGoodsList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods?` + params,
    method: "GET",
  });
};
// 获取商品列表v2
export const getGoodsListV2 = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods/list?` + params,
    method: "GET",
  });
};
// 入库
export const increaseGoods = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods`,
    method: "POST",
    data: params,
  });
};
// 获取商品详情列表
export const getGoodsDetailList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods/goods?` + params,
    method: "GET",
  });
};
// 获取入库详情列表
export const getWarehouseEntryDetailList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods/detailed?` + params,
    method: "GET",
  });
};
// 删除商品详情
export const delDetailGoods = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/warehouse_goods/${ids}`,
    method: "DELETE",
  });
};
